import React, { useRef, useState } from 'react';
import styles from '../../../component/addCategoryForm/addCategoryForm.module.css';
import styless from '../../../component/scheduleComps/scheduleList/partList.module.css';
import stylesp from '../prod.module.css';
import { AddCircle, closeCircle, UploadImg } from '../../../Svg';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { addTopProductsThunk } from '../../../redux/appearanceSlice';

const ManufacturerView = ({ manufacturer, level3, handleImageUpload, topproduct,index }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()



    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const formik = useFormik({
        initialValues: {
            manufacturer: topproduct?.manufacturer || "",
            productnumber: 1,
            product: topproduct?.product || [],
        },
        enableReinitialize: true, 
        
        onSubmit: async (values) => {
          
        },
    });


  

   

    return (
        <div  style={{ background: '#F0F1F3B2', marginBottom: '20px', padding: '8px 16px 16px' }}>
            <label className={styles.addCatLabel}>
                Manufacturer {index+1}

                
                <select
                    className={styles.addCatSelect}
                    value={formik.values.manufacturer}
                     disabled={true}
                >
                    {manufacturer?.map((i) => {
                        if (i?.thumbnail?.status === 'ACTIVE') {
                            return <option value={i?.name} key={i?.name}>{i?.name}</option>;
                        }
                        return null;
                    })}
                </select>
                
            </label>

            <label className={styles.addCatLabel}>Subcategories Level 3</label>
          

            <div style={{ margin: "15px 0", display: 'flex', flexWrap: "wrap", gap: "16px" }}>
                {formik.values.product?.map((product, index) => (
                    <div key={product.category} style={{ width: "23%" }}>
                        <div className={styles.tagsSug}>
                            <p style={{ color: "rgba(102, 102, 102, 1)", fontSize: 12 }}>
                                {level3?.find((i) => i._id === product.category)?.name || "Category"}
                            </p>
                         
                        </div>
                        <div className={styles.imageUpload}>
                          
                                    <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>

                                        <img src={product?.image} alt="" className={styles.previewImage} />


                    
                                    </div>
                                   

                        </div>
                    </div>
                ))}
            </div>

         
        </div>
    );
};

export default ManufacturerView;
